module.exports = __webpack_public_path__ + "img/dark-mud-decal-04.0bc01f89.png";